import React from 'react';
import { FileField, FileInput, useNotify, refreshView, useTranslate, useCreate } from 'react-admin';
import IconAdd from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import BaseDialog from '../../components/dialog/BaseDialog';

const CreatePaymentInstrumentDocument = ({ paymentInstrumentId }) => {
	const translate = useTranslate();
	const dispatch = useDispatch();
	const notify = useNotify();
	const [createPaymentInstrumentDocument] = useCreate('paymentInstrumentDocuments');

	const handleSubmit = (data, hideDialog) => {
		createPaymentInstrumentDocument(
			{
				payload: {
					id: paymentInstrumentId,
					data,
					method: null,
				},
			},
			{
				onSuccess: () => {
					notify('resources.paymentInstrumentDocuments.notifications.successfullyCreatedMessage', 'info');
					dispatch(refreshView());
					hideDialog();
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};

	return (
		<BaseDialog
			icon={<IconAdd />}
			buttonLabel={translate('resources.paymentInstrumentDocuments.actions.uploadDocument')}
			dialogTitle={translate('resources.paymentInstrumentDocuments.labels.createPaymentInstrumentDocument')}
			handleSubmit={handleSubmit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					onSubmit={values => handleSubmit(values, hideDialog)}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<FileInput source="file">
								<FileField source="src" title="title" />
							</FileInput>
						</form>
					)}
				/>
			)}
		</BaseDialog>
	);
};

export default CreatePaymentInstrumentDocument;
